export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13352.07b0a5db.jpg";